<template>
  <div>
    <LoadingPage v-if="isLoadPage" />
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-primary">
      <!-- Card stats -->
      <b-row> </b-row>
    </base-header>
    <b-container fluid class="mt--7">
      <b-row class="justify-content-center">
        <b-col lg="12">
          <card header-classes="bg-transparent">
            <b-row class="mb-4">
              <b-col lg="9" xl="10" md="12" class="d-flex flex-column mb-4">
                <h2 slot="header" class="mb-0">จัดการงาน</h2>
                <div class="text-body-1">
                  แสดงตารางรายละเอียดงานทั้งหมดที่มีอยู่
                </div>
              </b-col>
              <b-col lg="3" xl="2" md="12" class="text-right">
                <base-button
                  type="primary"
                  class="d-flex align-items-center"
                  block
                  @click="
                    $router.push({
                      name: 'createJob',
                    })
                  ">
                  <b-icon icon="plus-circle" class="mr-2"></b-icon> เพิ่มงานใหม่
                </base-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="3" md="12" class="mb-2">
                <b-form-datepicker
                  placeholder="วันที่เริ่ม"
                  v-model="dates.start"
                  :max="dates.end"
                  class="mb-2"
                  locale="th"></b-form-datepicker>
              </b-col>
              <b-col lg="3" md="12" class="mb-2">
                <b-form-datepicker
                  placeholder="วันที่สิ้นสุด"
                  v-model="dates.end"
                  :min="dates.start"
                  class="mb-2"
                  locale="th"></b-form-datepicker>
              </b-col>
              <b-col lg="2" md="12" class="mb-2">
                <b-form-select
                  v-model="jobTypeSelected"
                  value-field="id"
                  text-field="name"
                  :options="listJobType"></b-form-select>
              </b-col>
              <b-col lg="2" md="12" class="mb-2">
                <b-form-select
                  v-model="jobStatusSelected"
                  :options="listStatusJob"></b-form-select>
              </b-col>
              <b-col lg="2" md="12" class="mb-2">
                <b-button
                  variant="primary"
                  @click="getJob()"
                  block
                  class="d-flex align-items-center justify-content-center">
                  <b-icon icon="search" class="mr-2"></b-icon> ค้นหา
                </b-button>
              </b-col>
            </b-row>
            <!-- table -->
            <b-row class="mt-4">
              <b-col>
                <b-table
                  responsive
                  :fields="fields"
                  :items="items"
                  :busy="isLoading"
                  class="custom-table">
                  <template #cell(index)="data">
                    {{
                      calculateIndex(
                        data,
                        pagination.currentPage,
                        pagination.perPage
                      )
                    }}
                  </template>
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                    </div>
                  </template>
                  <template #cell(net)="data">
                    {{ +data.item.net | number }}
                  </template>
                  <template #cell(status)="data">
                    <template v-if="data.item.status === 'success'">
                      <b-badge variant="success" class="w-100"
                        >เสร็จสิ้น</b-badge
                      >
                    </template>
                    <template v-else-if="data.item.status === 'wait'">
                      <b-badge variant="dark" class="w-100"
                        >รอดำเนินการ</b-badge
                      >
                    </template>
                    <template v-else>
                      <b-badge variant="yellow" class="w-100"
                        >กำลังดำเนินการ</b-badge
                      >
                    </template>
                  </template>
                  <template #cell(manage)="data">
                    <b-button
                      variant="outline-border"
                      size="sm"
                      @click="
                        $router.push({
                          name: 'jobDeatil',
                          params: { id: data.item.id },
                        })
                      ">
                      <b-icon icon="pencil-square"></b-icon>
                    </b-button>
                    <b-button
                      variant="outline-danger"
                      size="sm"
                      :disabled="
                        ['inprogress', 'success'].includes(data.item.status)
                      "
                      @click="openModalConfirm(data.item.id)">
                      <b-icon icon="trash-fill"></b-icon>
                    </b-button>
                  </template>
                </b-table>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="d-flex justify-content-end">
                <b-pagination
                  v-model="pagination.currentPage"
                  :disabled="isLoading"
                  :total-rows="pagination.totalRows"
                  :per-page="pagination.perPage"
                  aria-controls="my-table"
                  class="mt-3"
                  @change="(page) => getJob(page)"></b-pagination>
              </b-col>
            </b-row>
          </card>
        </b-col>
      </b-row>
    </b-container>
    <ModalConfirm
      ref="confirmDelete"
      :confirm="confirm"
      @confirmModal="onDeleteJob" />
  </div>
</template>
<script>
import jobServices from "@/api/job.service.js";
import calculateIndex from "@/util/calculateIndex.js";
import ModalConfirm from "@/components/Modal/Alert/ModalConfirm.vue";
import { getCurrentDateInThaiFormat } from "@/util/datetime-manager.js";

export default {
  components: { ModalConfirm },
  props: {},
  data() {
    return {
      isLoadPage: false,
      calculateIndex,
      isLoading: false,
      pagination: {
        currentPage: 1,
        perPage: 10,
        totalRows: 0, // จำนวนข้อมูลทั้งหมด
      },
      confirm: {
        show: false,
        icon: '<i class="fas fa-times-circle text-red fa-5x"></i>',
        emphasize: "ต้องการลบรายการ",
        text: "กรุณาตรวจสอบข้อมูล หากลบรายการแล้วจะไม่สามารถกู้คืนได้",
        isLoad: false,
        id: null,
      },
      dates: {
        start: getCurrentDateInThaiFormat(),
        end: getCurrentDateInThaiFormat(),
      },
      jobTypeSelected: null,
      jobStatusSelected: null,
      listJobType: [],
      listStatusJob: [
        { value: null, text: "สถานะงานทั้งหมด" },
        { value: "wait", text: "รอดำเนินการ" },
        { value: "inprogress", text: "กำลังดำเนินการ" },
        { value: "success", text: "เสร็จสิ้น" },
      ],
      items: [],
      fields: [
        {
          key: "index",
          label: "#",
        },
        {
          key: "started_datetime",
          label: "วันที่กำหนดเริ่มงาน",
          formatter: (value) => {
            if (!value) return "";

            // แปลง value เป็นวันที่ JavaScript (สมมติว่า value อยู่ในรูปแบบ ISO 8601)
            const date = new Date(value);

            // จัดรูปแบบวันที่เป็น YYYY-MM-DD
            const formattedDate = date.toISOString().split("T")[0];

            // จัดรูปแบบเวลาเป็น HH:mm
            const formattedTime = date
              .toTimeString()
              .split(" ")[0]
              .substring(0, 5);

            // รวมวันที่และเวลา
            return `${formattedDate} ${formattedTime}`;
          },
        },
        {
          key: "created_date",
          label: "วันที่สร้างงาน",
          formatter: (value) => {
            if (!value) return "";

            // แปลง value เป็นวันที่ JavaScript (สมมติว่า value อยู่ในรูปแบบ ISO 8601)
            const date = new Date(value);

            // จัดรูปแบบวันที่เป็น YYYY-MM-DD
            const formattedDate = date.toISOString().split("T")[0];

            // จัดรูปแบบเวลาเป็น HH:mm
            const formattedTime = date
              .toTimeString()
              .split(" ")[0]
              .substring(0, 5);

            // รวมวันที่และเวลา
            return `${formattedDate} ${formattedTime}`;
          },
        },
        {
          key: "jobRateType.name",
          label: "ประเภทงาน",
        },
        {
          key: "status",
          label: "สถานะงาน",
        },
        {
          key: "driver.firstname",
          label: "ชื่อคนขับ",
        },
        {
          key: "job_name",
          label: "ชื่องาน",
        },
        {
          key: "customer_shop_name",
          label: "ชื่อบริษัท/ร้านค้า",
        },
        {
          key: "net",
          label: "ราคาสุทธิ",
        },
        {
          key: "manage",
          label: "การจัดการ",
        },
      ],
    };
  },
  created() {
    this.getJob();
    this.getRateTypesJobs();
  },
  methods: {
    async getRateTypesJobs() {
      try {
        const response = await jobServices.getRateTypesJobs();
        this.listJobType = [
          ...[{ id: null, name: "เลือกทั้งหมด" }],
          ...response.data.data,
        ];
      } catch (err) {}
    },
    async getJob(page = 1) {
      this.isLoading = true;
      this.isLoadPage = true;
      const param = {
        page,
        job_rate_type_id: this.jobTypeSelected,
        started_datetime: this.dates.start,
        ended_datetime: this.dates.end,
        status: this.jobStatusSelected,
      };
      try {
        const response = await jobServices.getJob(param);
        this.items = response.data.data.items;
        this.pagination.totalRows = response.data.data.meta.totalItems;
        this.pagination.perPage = response.data.data.meta.itemsPerPage;
        this.pagination.currentPage = response.data.data.meta.currentPage;
        this.isLoading = false;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoadPage = false;
      }
    },
    async onDeleteJob() {
      try {
        this.isLoadPage = true;

        await jobServices.removeJob(this.confirm.id);
        this.getJob();
        this.$refs.confirmDelete.closeModalConfirm();
      } catch (error) {
      } finally {
        this.isLoadPage = false;
      }
    },
    openModalConfirm(jobId) {
      this.confirm.show = true;
      this.confirm.id = jobId;
      this.confirm.icon = '<i class="fas fa-times-circle text-red fa-5x"></i>';
      this.confirm.emphasize = "ต้องการลบรายการ";
      this.confirm.text =
        "กรุณาตรวจสอบข้อมูล หากลบรายการแล้วจะไม่สามารถกู้คืนได้";
    },
  },
  mounted() {},
};
</script>
<style scoped></style>
<style lang="scss" scoped></style>
